import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import { H2, H3, P } from "../../typography"
import { Span, Reference } from "./styles"
import Button from "../../button"

const References = ({ references, rft_references, channel_host_word, openReference }) => (
  <Grid gap="0">
    <H2 variant="primary" profile>
      References
    </H2>
    {(references && references.length > 0) || (rft_references && rft_references.length > 0) ? (
      <Grid gap="24px">
        {[rft_references, references].map(
          (referenceList) =>
            referenceList &&
            referenceList.length > 0 && (
              <Grid gap="24px" key={referenceList === references ? "personal" : "previous"}>
                {referenceList.map((reference, index) => (
                  <Reference key={reference.id}>
                    {openReference && (
                      <Span>
                        <Button onClick={() => openReference(reference.id)} size="small" variant="primary" outlined>
                          Download PDF
                        </Button>
                      </Span>
                    )}

                    <Grid gap="12px">
                      <H3 marginless variant="content" profile>
                        {referenceList === references
                          ? `Personal Reference ${index + 1}`
                          : `${channel_host_word} Reference`}
                      </H3>

                      <Grid template="auto / 1fr" gap="24px">
                        {reference.fieldsets.map((fieldset) =>
                          fieldset.fields.map((field, index) => (
                            <Grid gap="4px" key={index}>
                              <P marginless variant="content" profileLabel>
                                {field.label}
                              </P>
                              <P marginless variant="content" profileData>
                                {field.answer}
                              </P>
                            </Grid>
                          ))
                        )}
                      </Grid>
                    </Grid>
                  </Reference>
                ))}
              </Grid>
            )
        )}
      </Grid>
    ) : (
      <P variant="content" profileData>
        No references.
      </P>
    )}
  </Grid>
)

References.propTypes = {
  references: PropTypes.array.isRequired,
  openReference: PropTypes.func
}

References.defaultProps = {
  references: [],
  openReference: undefined
}

export default References
